/**
 * Format structured mail-order shipping fields for order storage / API.
 */

const COUNTRY_LABELS = {
  CA: 'Canada',
  US: 'United States',
  INTL: 'International',
};

export function formatMailOrderShippingAddress({
  street = '',
  street2 = '',
  city = '',
  province = '',
  postalCode = '',
  countryCode = 'CA',
} = {}) {
  const countryLabel = COUNTRY_LABELS[countryCode] || countryCode;
  const cityLine = [city, province, postalCode].filter(Boolean).join(', ');
  return [street.trim(), street2.trim(), cityLine, countryLabel]
    .filter(Boolean)
    .join('\n')
    .trim();
}

/** Apply legacy single-field draft or checkout object into structured fields. */
export function resolveMailOrderAddressFields(draft = {}) {
  if (draft.shippingStreet != null || draft.shippingCity != null || draft.shippingPostalCode != null) {
    return {
      street: draft.shippingStreet || '',
      street2: draft.shippingStreet2 || '',
      city: draft.shippingCity || '',
      postalCode: draft.shippingPostalCode || '',
    };
  }

  if (draft.shippingAddress && typeof draft.shippingAddress === 'object') {
    const a = draft.shippingAddress;
    return {
      street: a.street || '',
      street2: a.street2 || '',
      city: a.city || '',
      postalCode: a.postalCode || '',
    };
  }

  if (typeof draft.shippingAddress === 'string' && draft.shippingAddress.trim()) {
    const lines = draft.shippingAddress.split('\n').map((l) => l.trim()).filter(Boolean);
    return {
      street: lines[0] || '',
      street2: lines.length > 3 ? lines[1] : '',
      city: '',
      postalCode: '',
    };
  }

  return { street: '', street2: '', city: '', postalCode: '' };
}
